import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { map as _map } from 'lodash';

import localize from 'components/Localize/Localize';
import PurchaserRating from 'components/PurchaserRating/PurchaserRating';

import styles from './RatingLogos.css';
import translations from './translations';

const cx = classNames.bind(styles);

const renderLegal = (props) => {
  if (!props.t.legal) {
    return null;
  }
  const copyClass = cx(`rating-detail-copy`, {
    'rating-detail-copy--large': props.largeIcon,
  });

  return <p className={copyClass}>{props.t.legal}</p>;
};

const RatingLogos = (props) => {
  const containerClass = cx(`container`, {
    'container--large': props.largeIcon,
    [props.containerStyles]: props.containerStyles,
  });

  const logoClass = cx(`logo`, {
    'logo--large': props.largeIcon,
  });

  const outerContainerClass = cx({ 'outer-container': props.largeIcon});

  return (
    <div className={outerContainerClass}>
      <div className={containerClass}>
        {_map(props.t.stores, (store) => {
          const avgRating = store.id === `casper` ? props.casperReviewsAvgRating : store.avgRating;
          const totalCount = store.id === `casper` ? props.casperReviewsTotalCount : store.totalCount;

          return (
            <div
              className={styles[`ratings`]}
              key={store.id}
            >
              <img
                alt={store.imageAlt}
                className={logoClass}
                src={`/assets-spa/images/${store.imagePath}`}
              />
              <PurchaserRating
                asterisk={props.asterisk}
                avgRating={avgRating}
                displayType={props.displayType}
                hideCountMobile={props.hideCountMobile}
                largeIcon={props.largeIcon}
                parenthesis={props.parenthesis}
                plusKey={props.plusKey}
                showAverage={props.showAverage}
                showTotalCount={props.showTotalCount}
                totalCount={totalCount}
              />
            </div>
          );
        })}
      </div>
      {renderLegal(props)}
    </div>
  );
};

RatingLogos.propTypes = {
  asterisk: PropTypes.bool,
  casperReviewsAvgRating: PropTypes.number.isRequired,
  casperReviewsTotalCount: PropTypes.number.isRequired,
  containerStyles: PropTypes.string,
  displayType: PropTypes.oneOf([ `column`, `row` ]),
  hideCountMobile: PropTypes.bool,
  largeIcon: PropTypes.bool,
  parenthesis: PropTypes.bool,
  plusKey: PropTypes.bool,
  showAverage: PropTypes.bool,
  showTotalCount: PropTypes.bool,
  t: PropTypes.shape({
    legal: PropTypes.string.isRequired,
    stores: PropTypes.arrayOf(PropTypes.shape({
      avgRating: PropTypes.number,
      id: PropTypes.string.isRequired,
      imagePath: PropTypes.string.isRequired,
      totalCount: PropTypes.number,
    })).isRequired,
  }).isRequired,
};

RatingLogos.defaultProps = {
  asterisk: false,
  displayType: `column`,
  hideCountMobile: false,
  parenthesis: false,
  plusKey: true,
  showAverage: false,
  showTotalCount: true,
};

export default localize(RatingLogos, translations);
